// useAuth.js - Authentication ONLY
import { useState, useEffect } from 'react';
import { auth } from '../Config/firebase.js';

const useAuth = () => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((currentUser) => {
      setUser(currentUser);
      if (!currentUser) {
        console.log('User not authenticated, redirecting to /index.html');
        window.location.href = '/index.html';
      } else {
        console.log('User authenticated:', currentUser.uid);
      }
    });
    return () => unsubscribe();
  }, []);

  return { user };
};

export default useAuth;